import React, { useState } from 'react';
import Button from '../../ui/Button/Button';
import Dialog from '../../ui/Dialog/Dialog';
import Icon from '../../ui/Icon';
import { ICONS } from '../../ui/icon-map';
import LoadingSpinner from '../../components/LoadingSpinner';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableHeader, TableCell } from '../../ui/Table/Table';
import { CellText, CellPlate, CellMoney } from '../../ui/DataTable/cells';
import { Input } from '../../ui/Field/Field';
import { finesService, fmtAED, errorMessage } from '../../services/finesService';
import { useRowLinks } from '../TrafficFines/components/jobLinks';
import { Pill } from '../TrafficFines/components/ui';

// What THE ENGINE put on Ejar between two moments (owner, 7 Oct 2026: "زر صريح ... اختار التاريخ والوقت من والى علشان
// يظهرلي ايه اللي اتسجل فعلا على ايجار من المحرك"): parking lines, Salik / Darb lines (their trips grouped), fines -
// from the engine's own marks, never from Ejar's screen. A person's own entries on Ejar are not here.

const KIND = { parking: ['Parking', 'indigo'], salik: ['Salik / Darb line', 'purple'], fine: ['Fine', 'amber'] };
const local = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;

export default function RegisteredOnEjarModal({ onClose }) {
    // today in Dubai from 00:00 to now - the inputs hold Dubai wall time whatever the browser's zone
    const nowDubai = new Date(Date.now() + 4 * 3600e3);
    const wallNow = new Date(nowDubai.getUTCFullYear(), nowDubai.getUTCMonth(), nowDubai.getUTCDate(), nowDubai.getUTCHours(), nowDubai.getUTCMinutes());
    const [from, setFrom] = useState(local(new Date(wallNow.getFullYear(), wallNow.getMonth(), wallNow.getDate(), 0, 0)));
    const [to, setTo] = useState(local(wallNow));
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const { FineLink, ContractLink, modals } = useRowLinks();

    const load = async () => {
        setBusy(true); setError(null); setData(null);
        try { setData(await finesService.registeredOnEjar(from, to)); } catch (e) { setError(errorMessage(e)); }
        setBusy(false);
    };
    const rows = data?.rows || [];
    const totals = data?.totals || {};

    return (
        <Dialog open onClose={onClose} size="xl" title="Registered on Ejar automatically by the engine">
            <div className="sticky top-0 z-10 bg-white pb-2 -mt-1 pt-1">
                <div className="flex flex-wrap items-end gap-3 text-sm">
                    <label className="flex flex-col gap-1 text-gray-700">From
                        <Input type="datetime-local" value={from} onChange={(e) => setFrom(e.target.value)} />
                    </label>
                    <label className="flex flex-col gap-1 text-gray-700">To
                        <Input type="datetime-local" value={to} onChange={(e) => setTo(e.target.value)} />
                    </label>
                    <Button variant="primary" size="sm" onClick={load} disabled={busy || !from || !to} leadingIcon={<Icon glyph={ICONS.search} size="sm" />}>Show</Button>
                    {data && (
                        <span className="text-gray-700">
                            <b>{data.count}</b> entries · <b>{fmtAED(data.total)}</b>
                            {Object.entries(totals).map(([k, t]) => <span key={k} className="ml-2">{KIND[k]?.[0] || k}: {t.count} · {fmtAED(t.aed)}</span>)}
                        </span>
                    )}
                </div>
                {error && <div role="alert" className="mt-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}
            </div>
            {busy && <LoadingSpinner message="Reading the engine's own ledger…" />}
            {data && !busy && (rows.length === 0 ? <div className="text-sm text-gray-500 mt-2">The engine registered nothing automatically in this period.</div> : (
                <TableContainer maxHeight={560}>
                    <Table sticky>
                        <TableHead><TableRow>
                            <TableHeader>#</TableHeader><TableHeader>Kind</TableHeader><TableHeader>Registered at</TableHeader><TableHeader>Contract</TableHeader>
                            <TableHeader>Customer</TableHeader><TableHeader>Car</TableHeader><TableHeader>What</TableHeader><TableHeader>Trip / parking time</TableHeader>
                            <TableHeader>AED</TableHeader><TableHeader>By</TableHeader>
                        </TableRow></TableHead>
                        <TableBody>{rows.map((r, i) => (
                            <TableRow key={`${r.kind}-${r.contract}-${r.what}-${i}`}>
                                <TableCell><span className="ds-cell-num">{i + 1}</span></TableCell>
                                <TableCell><Pill tone={KIND[r.kind]?.[1] || 'gray'} size="sm">{KIND[r.kind]?.[0] || r.kind}{r.trips > 1 ? ` · ${r.trips} trips` : ''}</Pill></TableCell>
                                <TableCell><span className="ds-cell-date">{r.registeredAt}</span></TableCell>
                                <TableCell>{r.contract ? <ContractLink contract={r.contract} customer={r.customer} plate={r.plate} /> : '—'}</TableCell>
                                <TableCell><CellText>{r.customer}</CellText></TableCell>
                                <TableCell><CellPlate>{r.plate}</CellPlate></TableCell>
                                <TableCell>{r.kind === 'fine' ? <FineLink ticket={r.ticket} /> : <CellText>{r.what}</CellText>}</TableCell>
                                <TableCell><span className="ds-cell-date">{r.when}</span></TableCell>
                                <TableCell><CellMoney value={Number(r.amount || 0)} currency="AED" /></TableCell>
                                <TableCell><CellText>{r.by || 'automatic'}</CellText></TableCell>
                            </TableRow>))}</TableBody>
                    </Table>
                </TableContainer>
            ))}
            {modals}
        </Dialog>
    );
}
